import { render, staticRenderFns } from "./UserCardComponent.vue?vue&type=template&id=49a386a4&scoped=true&"
import script from "./UserCardComponent.vue?vue&type=script&lang=js&"
export * from "./UserCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a386a4",
  null
  
)

export default component.exports